import React from 'react';
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import HomeIcon from '@material-ui/icons/Home'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import { 
  AppBar,
  Button,
  IconButton,
  Toolbar,
  Typography,
} from '@material-ui/core' 

import { authLogOut } from '../../redux/ducks/auth';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  linkIconButton: {
    marginRight: theme.spacing(1.5),
    color: 'white'
  },
  title: {
    flexGrow: 1,
    textAlign: 'center'
  },
}));

export function NavBar() {
  const classes = useStyles()
  const dispatch = useDispatch()

  const logout = () => {
    console.log('logging out')
    dispatch(authLogOut())
  }

  return (
    <AppBar position="sticky">
      <Toolbar>
        <Link to='/dashboard'>
          <IconButton edge="start" className={classes.linkIconButton} color="inherit" aria-label="menu">
            <HomeIcon />
          </IconButton>
        </Link>
        <Typography variant="h6" className={classes.title}>
          Calgaro Guide
        </Typography>
        <Link to='/usuarios'>
          <IconButton edge="start" className={classes.linkIconButton} color="inherit" aria-label="logout">
            <AccountCircleIcon />
          </IconButton>
        </Link>
        <IconButton 
          edge="start"
          color="inherit" 
          aria-label="logout"
          onClick={() => logout()}
        >
          <ExitToAppIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

export default NavBar;
